import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { NetworkStatus } from '@cbridge-utils/network';
import { MarkupProfileAction } from './markupProfile.action';
import { markupProfileInitialState } from './markupProfile.constant';
import { IMarkupProfileStore } from './markupProfile.interface';

export const markupProfileReducer = reducerWithInitialState(markupProfileInitialState)
  .case(MarkupProfileAction.loadList.started, (state): IMarkupProfileStore => {
    return {
      ...state,
      listNetworkStatus: NetworkStatus.Started,
    };
  })
  .case(MarkupProfileAction.loadList.done, (state, { result }): IMarkupProfileStore => {
    const dataRecord = Object.fromEntries(result.map((profile) => [profile.markupProfileId, profile]));
    return {
      ...state,
      data: dataRecord,
      listNetworkStatus: NetworkStatus.Done,
    };
  })
  .case(MarkupProfileAction.loadList.failed, (state): IMarkupProfileStore => {
    return {
      ...state,
      listNetworkStatus: NetworkStatus.Failed,
    };
  })
  .case(MarkupProfileAction.load.started, (state, { profileId }): IMarkupProfileStore => {
    const { data } = state;
    const profileData = data[profileId];

    return {
      ...state,
      data: {
        ...data,
        [profileId]: {
          ...profileData,
          networkStatus: NetworkStatus.Started,
        },
      },
    };
  })
  .case(MarkupProfileAction.load.done, (state, payload): IMarkupProfileStore => {
    const { data } = state;
    const { params: { profileId }, result } = payload;

    return {
      ...state,
      data: {
        ...data,
        [profileId]: {
          ...result,
          networkStatus: NetworkStatus.Done,
        },
      },
    };
  })
  .case(MarkupProfileAction.load.failed, (state, { params }): IMarkupProfileStore => {
    const { data } = state;
    const { profileId } = params;
    const profileData = data[profileId];

    return {
      ...state,
      data: {
        ...data,
        [profileId]: {
          ...profileData,
          networkStatus: NetworkStatus.Failed,
        },
      },
    };
  })
  .case(MarkupProfileAction.remove.done, (state, { params }): IMarkupProfileStore => {
    const { data } = state;
    const { profileId } = params;

    delete data[profileId];

    return {
      ...state,
      data: {
        ...data,
      },
    };
  })
  .case(MarkupProfileAction.destroy, () => ({
    ...markupProfileInitialState,
  }));
